import {
  getBakeryArtworkNFTAddress,
  getArtworkNftAddress,
  getOneInchBakeNFTAddress,
  getBakeryArtwork2NFTAddress,
  getBakeryArtwork3NFTAddress,
  getSeascapeNFTAddress,
  getBakerySoccerAddress,
  getTokocryptoNFTAddress,
  getSfpNFTAddress,
  getDoggyNFTAddress,
  getLoveNFTAddress,
  getYooshiNFTAddress,
  getRacaNFTAddress,
  getDishAddress,
  getBinanceNftAddress,
  getPetNftAddress,
  getBondlyNftAddress,
  getBscBakeNFTAddress,
  getBarkingNFTAddress,
  getTokauNFTAddress,
  getPokerCardAddress,
  getDoggyEquipmentAddress,
  getMatrixPlusBoxAddress,
  getToysAddress,
  getKtaNFTAddress,
  getCarNFTAddress,
  getPetEggNftAddress,
  getWeaponNFTAddress,
  getNewDonghuangArtAddress,
  getBmoncAddress,
  getGaAddress,
  getKRabbitAddress,
  getKTreasureAdvancedAddress,
  getKmoNFTAddress
} from '../sushi/utils'
import { getBakeMuskMixerAddress } from '../sushi/bakeMuskMixer'
import { getMuskUsmLandAddress } from '../sushi/muskUsmLand'
import { contractAddresses } from '../sushi/lib/constants'

import { MARKETTYPE, MARKETTYPEV1, MARKETMULTITOKEN, MARKETTYPEV3 } from '../constants/bakery/nft'

export function userNftAddress(sushi: any, type?: string) {
  let address = getDishAddress(sushi)
  switch (type) {
    case MARKETTYPE.DISH:
    case MARKETTYPEV1.DISHV1:
    case MARKETTYPEV3.DISHV3:
      address = getDishAddress(sushi)
      break
    case MARKETTYPE.BINANCENFT:
    case MARKETTYPEV1.BINANCENFTV1:
    case MARKETTYPEV3.BINANCENFTV3:
      address = getBinanceNftAddress(sushi)
      break
    case MARKETTYPE.PETNFT:
    case MARKETTYPEV1.PETNFTV1:
    case MARKETTYPEV3.PETNFTV3:
      address = getPetNftAddress(sushi)
      break
    case MARKETTYPE.BAKERYARTWORK:
    case MARKETTYPEV1.BAKERYARTWORKV1:
    case MARKETTYPEV3.BAKERYARTWORKV3:
      address = getBakeryArtworkNFTAddress(sushi)
      break
    case MARKETTYPE.BTCARTWORK:
    case MARKETTYPEV1.BTCARTWORKV1:
    case MARKETTYPEV3.BTCARTWORKV3:
      address = getArtworkNftAddress(sushi)
      break
    case MARKETTYPE.SEASCAPE:
    case MARKETTYPEV1.SEASCAPEV1:
    case MARKETTYPEV3.SEASCAPEV3:
      address = getSeascapeNFTAddress(sushi)
      break
    case MARKETTYPE.ARTWORK:
    case MARKETTYPEV1.ARTWORKV1:
    case MARKETTYPEV3.ARTWORKV3:
      address = getArtworkNftAddress(sushi)
      break
    case MARKETTYPE.ONEINCH:
    case MARKETTYPEV1.ONEINCHV1:
    case MARKETTYPEV3.ONEINCHV3:
      address = getOneInchBakeNFTAddress(sushi)
      break
    case MARKETTYPE.MEME:
    case MARKETTYPEV1.MEMEV1:
    case MARKETTYPEV3.MEMEV3:
      address = getBakeryArtwork3NFTAddress(sushi)
      break
    case MARKETTYPE.MUSKDOGE:
    case MARKETTYPEV1.MUSKDOGEV1:
    case MARKETTYPEV3.MUSKDOGEV3:
      address = getBakeryArtwork2NFTAddress(sushi)
      break
    case MARKETTYPE.BAKERYSOCCER:
    case MARKETTYPEV1.BAKERYSOCCERV1:
    case MARKETTYPEV3.BAKERYSOCCERV3:
      address = getBakerySoccerAddress(sushi)
      break
    case MARKETTYPE.TKONFT:
    case MARKETTYPEV1.TKONFTV1:
    case MARKETTYPEV3.TKONFTV3:
      address = getTokocryptoNFTAddress(sushi)
      break
    case MARKETTYPE.SFPARTWORK:
    case MARKETTYPEV1.SFPARTWORKV1:
    case MARKETTYPEV3.SFPARTWORKV3:
      address = getSfpNFTAddress(sushi)
      break
    case MARKETTYPE.DOGGYNFT:
    case MARKETTYPEV1.DOGGYNFTV1:
    case MARKETTYPEV3.DOGGYNFTV3:
      address = getDoggyNFTAddress(sushi)
      break
    case MARKETTYPE.LOVE:
    case MARKETTYPEV1.LOVEV1:
    case MARKETTYPEV3.LOVEV3:
      address = getLoveNFTAddress(sushi)
      break
    case MARKETTYPE.YOOSHINFT:
    case MARKETTYPEV1.YOOSHINFTV1:
    case MARKETTYPEV3.YOOSHINFTV3:
      address = getYooshiNFTAddress(sushi)
      break
    case MARKETTYPE.RACANFT:
    case MARKETTYPEV1.RACANFTV1:
    case MARKETTYPEV3.RACANFTV3:
    case MARKETMULTITOKEN.RACAMULTITOKEN:
      address = getRacaNFTAddress(sushi)
      break
    case MARKETTYPE.BONDLYNFT:
    case MARKETTYPEV1.BONDLYNFTV1:
    case MARKETTYPEV3.BONDLYNFTV3:
      address = getBondlyNftAddress(sushi)
      break
    case MARKETTYPE.BAKERYBSCARTWORK:
    case MARKETTYPEV1.BAKERYBSCARTWORKV1:
    case MARKETTYPEV3.BAKERYBSCARTWORKV3:
      address = getBscBakeNFTAddress(sushi)
      break
    case MARKETTYPE.POKERCARD:
    case MARKETTYPEV3.POKERCARDV3:
    case MARKETMULTITOKEN.POKERMULTITOKEN:
      address = getPokerCardAddress(sushi)
      break
    case MARKETTYPE.BARKNFT:
    case MARKETTYPEV1.BARKNFTV1:
    case MARKETTYPEV3.BARKNFTV3:
      address = getBarkingNFTAddress(sushi)
      break;
    case MARKETMULTITOKEN.TOKAUMULTITOKEN:
    case MARKETTYPEV3.TOKAUV3:
      address = getTokauNFTAddress(sushi)
      break;
    case MARKETMULTITOKEN.EQUIPMENTMULTITOKEN:
    case MARKETTYPEV3.EQUIPMENTV3:
      address = getDoggyEquipmentAddress(sushi)
      break;
    case MARKETMULTITOKEN.MATRIXMULTITOKEN:
    case MARKETTYPEV3.MATRIXV3:
      address = getMatrixPlusBoxAddress(sushi)
      break
    case MARKETMULTITOKEN.TOYMULTITOKEN:
    case MARKETTYPEV3.TOYV3:
      address = getToysAddress(sushi)
      break
    case MARKETMULTITOKEN.KAKAMULTITOKEN:
    case MARKETTYPEV3.KAKAV3:
      address = getKtaNFTAddress(sushi)
      break
    case MARKETMULTITOKEN.BAKEMUSKMIXERMULTITOKEN:
    case MARKETTYPEV3.BAKEMUSKV3:
      address = getBakeMuskMixerAddress(sushi)
      break
    case MARKETTYPE.CARNFT:
    case MARKETTYPEV3.CARNFTV3:
      address = getCarNFTAddress(sushi)
      break
    case MARKETTYPE.EGGNFT:
    case MARKETTYPEV1.EGGNFTV1:
    case MARKETTYPEV3.EGGNFTV3:
      address = getPetEggNftAddress(sushi)
      break
    case MARKETTYPE.WEAPONNFT:
    case MARKETTYPEV1.WEAPONNFTV1:
    case MARKETTYPEV3.WEAPONNFTV3:
      address = getWeaponNFTAddress(sushi)
      break
    case MARKETTYPEV3.MUSKUSMLANDNFTV3:
      address = getMuskUsmLandAddress(sushi)
      break
    case MARKETTYPEV3.BLINV3:
      address = getNewDonghuangArtAddress(sushi)
      break
    case MARKETTYPEV3.BINAMONV3:
      address = getBmoncAddress(sushi)
      break
    case MARKETTYPEV3.GAV3:
      address = getGaAddress(sushi)
      break
    case MARKETTYPEV3.KRBV3:
      address = getKRabbitAddress(sushi)
      break
    case MARKETTYPEV3.KTAV3:
      address = getKTreasureAdvancedAddress(sushi)
      break
    case MARKETTYPEV3.KRIPTOMONV3:
      address = getKmoNFTAddress(sushi)
      break
  }
  return address
}

export function userNftAddressNoAccount(type?: string) {
  let contractId = contractAddresses.bscBakeNFT
  switch (type) {
    case MARKETTYPEV3.WEAPONNFTV3:
    case MARKETTYPE.WEAPONNFT:
    case MARKETTYPEV1.WEAPONNFTV1:
      contractId = contractAddresses.weaponNFT
      break
    case MARKETTYPEV3.PETNFTV3:
    case MARKETTYPE.PETNFT:
    case MARKETTYPEV1.PETNFTV1:
      contractId = contractAddresses.petNft
      break
    case MARKETTYPEV3.EGGNFTV3:
    case MARKETTYPE.EGGNFT:
    case MARKETTYPEV1.EGGNFTV1:
      contractId = contractAddresses.petEggNft
      break
    case MARKETTYPEV3.DISHV3:
    case MARKETTYPE.DISH:
    case MARKETTYPEV1.DISHV1:
      contractId = contractAddresses.dish
      break
    case MARKETTYPE.BAKERYARTWORK:
    case MARKETTYPEV1.BAKERYARTWORKV1:
    case MARKETTYPEV3.BAKERYARTWORKV3:
      contractId = contractAddresses.bakeryArtworkNFT
      break
    case MARKETTYPE.SEASCAPE:
    case MARKETTYPEV1.SEASCAPEV1:
    case MARKETTYPEV3.SEASCAPEV3:
      contractId = contractAddresses.seascapeNFT
      break
    case MARKETTYPE.ARTWORK:
    case MARKETTYPEV1.ARTWORKV1:
    case MARKETTYPEV3.ARTWORKV3:
      contractId = contractAddresses.digitalArtworkNft
      break
    case MARKETTYPE.ONEINCH:
    case MARKETTYPEV1.ONEINCHV1:
    case MARKETTYPEV3.ONEINCHV3:
      contractId = contractAddresses.oneInchBakeNFT
      break
    case MARKETTYPE.MEME:
    case MARKETTYPEV1.MEMEV1:
    case MARKETTYPEV3.MEMEV3:
      contractId = contractAddresses.bakeryArtwork3NFT
      break
    case MARKETTYPE.MUSKDOGE:
    case MARKETTYPEV1.MUSKDOGEV1:
    case MARKETTYPEV3.MUSKDOGEV3:
      contractId = contractAddresses.bakeryArtwork2NFT
      break
    case MARKETTYPE.BAKERYSOCCER:
    case MARKETTYPEV1.BAKERYSOCCERV1:
    case MARKETTYPEV3.BAKERYSOCCERV3:
      contractId = contractAddresses.bakerySoccer
      break
    case MARKETTYPE.TKONFT:
    case MARKETTYPEV1.TKONFTV1:
    case MARKETTYPEV3.TKONFTV3:
      contractId = contractAddresses.tokocryptoNft
      break
    case MARKETTYPE.SFPARTWORK:
    case MARKETTYPEV1.SFPARTWORKV1:
    case MARKETTYPEV3.SFPARTWORKV3:
      contractId = contractAddresses.sfpNFT
      break
    case MARKETTYPE.DOGGYNFT:
    case MARKETTYPEV1.DOGGYNFTV1:
    case MARKETTYPEV3.DOGGYNFTV3:
      contractId = contractAddresses.doggyNFT
      break
    case MARKETTYPE.LOVE:
    case MARKETTYPEV1.LOVEV1:
    case MARKETTYPEV3.LOVEV3:
      contractId = contractAddresses.loveNFT
      break
    case MARKETTYPE.BARKNFT:
    case MARKETTYPEV1.BARKNFTV1:
    case MARKETTYPEV3.BARKNFTV3:
      contractId = contractAddresses.barkingNFT
      break
    case MARKETTYPE.YOOSHINFT:
    case MARKETTYPEV1.YOOSHINFTV1:
    case MARKETTYPEV3.YOOSHINFTV3:
      contractId = contractAddresses.yooshiNFT
      break
    case MARKETTYPE.RACANFT:
    case MARKETTYPEV1.RACANFTV1:
    case MARKETTYPEV3.RACANFTV3:
      contractId = contractAddresses.racaNFT
      break
    case MARKETTYPE.BONDLYNFT:
    case MARKETTYPEV1.BONDLYNFTV1:
    case MARKETTYPEV3.BONDLYNFTV3:
      contractId = contractAddresses.bondlyNft
      break
    case MARKETTYPE.BAKERYBSCARTWORK:
    case MARKETTYPEV1.BAKERYBSCARTWORKV1:
    case MARKETTYPEV3.BAKERYBSCARTWORKV3:
      contractId = contractAddresses.bscBakeNFT
      break
    case MARKETMULTITOKEN.EQUIPMENTMULTITOKEN:
    case MARKETTYPEV3.EQUIPMENTV3:
      contractId = contractAddresses.doggyEquipment
      break
    case MARKETMULTITOKEN.POKERMULTITOKEN:
    case MARKETTYPEV3.POKERCARDV3:
      contractId = contractAddresses.pokerCard
      break
    case MARKETMULTITOKEN.MATRIXMULTITOKEN:
    case MARKETTYPEV3.MATRIXV3:
      contractId = contractAddresses.matrixPlusBox
      break
    case MARKETMULTITOKEN.TOYMULTITOKEN:
    case MARKETTYPEV3.TOYV3:
      contractId = contractAddresses.toys
      break
    case MARKETMULTITOKEN.KAKAMULTITOKEN:
    case MARKETTYPEV3.KAKAV3:
      contractId = contractAddresses.ktaNFT
      break
    case MARKETMULTITOKEN.BAKEMUSKMIXERMULTITOKEN:
    case MARKETTYPEV3.BAKEMUSKV3:
      contractId = contractAddresses.bakeMuskMixer
      break
    case MARKETMULTITOKEN.TOKAUMULTITOKEN:
      case MARKETTYPEV3.TOKAUV3:
        contractId = contractAddresses.tokauNFT
        break
    case MARKETTYPEV3.MUSKUSMLANDNFTV3:
      contractId = contractAddresses.muskUsmLand
      break
    case MARKETTYPEV3.BLINV3:
      contractId = contractAddresses.newDonghuangArt
      break
    case MARKETTYPEV3.BINAMONV3:
      contractId = contractAddresses.bmonc
      break
    case MARKETTYPEV3.GAV3:
      contractId = contractAddresses.ga
      break
    case MARKETTYPEV3.KTAV3:
      contractId = contractAddresses.kTreasureAdvanced
      break
    case MARKETTYPEV3.KRBV3:
      contractId = contractAddresses.kRabbit
      break
    case MARKETTYPEV3.KRIPTOMONV3:
      contractId = contractAddresses.kmoNFT
      break
  }
  return contractId
}

